import { render, staticRenderFns } from "./MobileNav.vue?vue&type=template&id=623b90a2&scoped=true"
import script from "./MobileNav.vue?vue&type=script&lang=js"
export * from "./MobileNav.vue?vue&type=script&lang=js"
import style0 from "./MobileNav.vue?vue&type=style&index=0&id=623b90a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b90a2",
  null
  
)

export default component.exports